import { FormattedMessage, useIntl } from 'react-intl';
import { Nav } from 'react-bootstrap';
import { NavLink } from 'react-router-dom';
import { AuthenticatedTemplate } from '@azure/msal-react';
import { NavRouteGuard } from './NavRouteGuard';
import { appRoles } from '../util/authUtil';

interface IMenuNavigationProps {
  userLoaded?: boolean;
}

export const MenuNavigation  = (props: IMenuNavigationProps) => {
  const intl = useIntl();

  if (!props.userLoaded) {
    return null;
  }
  return (
    <AuthenticatedTemplate>
      <nav id="main-nav" aria-label={ intl.formatMessage({ id: 'menu.main' })}>
        <Nav as="ul" className="navbar-nav">
          <Nav.Item as="li" >
            <span>
              <Nav.Link
                className="nav-link d-flex flex-row"
                as={NavLink}
                to="/home">
                <i aria-hidden="true" className="fa fa-home"></i>
                <span><FormattedMessage id="menu.home" /></span>
              </Nav.Link>
            </span>
          </Nav.Item>
          <NavRouteGuard  roles={[appRoles.GuestReporter]}>       
              <Nav.Link
                className="nav-link d-flex flex-row"
                as={NavLink}
                to="/profile/companyinfo">
                <i aria-hidden="true" className="fa fa-building-o"></i>
                <span><FormattedMessage id="menu.profile.companyinfo" /></span>
              </Nav.Link>
          </NavRouteGuard>
          <NavRouteGuard roles={[appRoles.Admin]} >    
              <Nav.Link
                className="nav-link d-flex flex-row"
                as={NavLink}
                to="/companymanagement">
                <i aria-hidden="true" className="fa fa-building"></i>
                <span><FormattedMessage id="menu.companymanagement" /></span>
              </Nav.Link>
          </NavRouteGuard>
          <NavRouteGuard  roles={[appRoles.Admin]}>
              <Nav.Link
                className="nav-link d-flex flex-row"
                as={NavLink}
                to="/usermanagement">
                <i aria-hidden="true" className="fa fa-users"></i>
                <span><FormattedMessage id="menu.usermanagement" /></span>
              </Nav.Link>  
          </NavRouteGuard>
          <NavRouteGuard  roles={[appRoles.Admin]}>     
              <Nav.Link
                className="nav-link d-flex flex-row"
                as={NavLink}
                to="/reportsAdmin">
                <i aria-hidden="true" className="fa fa-area-chart"></i>
                <span><FormattedMessage id="menu.reports" /></span>
              </Nav.Link>
          </NavRouteGuard>
          <NavRouteGuard  roles={[appRoles.Admin]}>
              <Nav.Link
                className="nav-link d-flex flex-row"
                as={NavLink}
                to="/bookkeeping">
                <i aria-hidden="true" className="fa fa-money"></i>
                <span><FormattedMessage id="menu.bookkeeping" /></span>
              </Nav.Link>
          </NavRouteGuard>
          <NavRouteGuard  roles={[appRoles.Admin]}>
              <Nav.Link
                className="nav-link d-flex flex-row"
                as={NavLink}
                to="/categories">
                <i aria-hidden="true" className="fa fa-cubes"></i>
                <span><FormattedMessage id="menu.categories" /></span>
              </Nav.Link>     
          </NavRouteGuard>
          <NavRouteGuard  roles={[appRoles.Admin]}>
              <Nav.Link
                className="nav-link d-flex flex-row"
                as={NavLink}
                to="/messages">
                <i aria-hidden="true" className="fa fa-envelope"></i>
                <span><FormattedMessage id="menu.messages" /></span>
              </Nav.Link>
          </NavRouteGuard>
          <NavRouteGuard  roles={[appRoles.Admin]}>
              <Nav.Link
                className="nav-link d-flex flex-row"
                as={NavLink}
                to="/languages">
                <i aria-hidden="true" className="fa fa-language"></i>
                <span><FormattedMessage id="menu.languages" /></span>
              </Nav.Link>    
          </NavRouteGuard>
          <NavRouteGuard  roles={[appRoles.Admin]}>  
              <Nav.Link
                className="nav-link d-flex flex-row"
                as={NavLink}
                to="/settings">
                <i aria-hidden="true" className="fa fa-cogs"></i>
                <span><FormattedMessage id="menu.settings" /></span>
              </Nav.Link>
          </NavRouteGuard>
        </Nav>
      </nav>
    </AuthenticatedTemplate>
  );
}
